import { render, staticRenderFns } from "./notificationIcon.vue?vue&type=template&id=23b0d882&"
import script from "./notificationIcon.vue?vue&type=script&lang=js&"
export * from "./notificationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports